import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgRocketshipGlyph from './svgs/RocketshipGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var rocketshipGlyph = (props => useIcon(SvgRocketshipGlyph, SvgRocketshipGlyph, props));

export { rocketshipGlyph as default };
